module.exports = __webpack_public_path__ + "img/firestone_banner.157f3767.png";